var React = require('react');

function TimelineTrailTwo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M340.5 4.9987C313.833 1.33204 251.8 11.2987 217 80.4987C173.5 166.999 192 241.499 113.5 259.499C50.7 273.899 14.3333 237.832 4 217.999","stroke":"#484B53","strokeOpacity":"0.18","strokeWidth":"8","strokeDasharray":"16 16"}));
}

TimelineTrailTwo.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 342 267","fill":"none"};

module.exports = TimelineTrailTwo;

TimelineTrailTwo.default = TimelineTrailTwo;
